module.exports = {
      id: "action-usage",
      viewBox: "0 0 22.626 18.6",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#action",
      toString: function () {
        return this.url;
      }
    }